/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArchive = createReactComponent("archive", "IconArchive", [
  [
    "path",
    {
      d: "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10", key: "svg-1" }],
  ["path", { d: "M10 12l4 0", key: "svg-2" }]
]);

export { IconArchive as default };
//# sourceMappingURL=IconArchive.js.map
